require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./label"), require("./backbutton"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./label", "./backbutton"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./label"), require("./backbutton")) : factory(root["./utils"], root["./label"], root["./backbutton"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__59__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[6],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(159);


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Breadcrumb = _interopRequireDefault(__webpack_require__(160));

exports["default"] = _Breadcrumb["default"];
exports.Breadcrumb = _Breadcrumb["default"];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _backbutton = _interopRequireDefault(__webpack_require__(59));

var _utils = __webpack_require__(4);

var _folderOverflow_ = _interopRequireDefault(__webpack_require__(161));

var _baUiCarbon = __webpack_require__(12);

var _label = _interopRequireDefault(__webpack_require__(19));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(162));

var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(163));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var breadcrumbItemClassName = _BreadcrumbItem2["default"].breadcrumbItemClassName.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var Breadcrumb = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Breadcrumb, _Component);

  function Breadcrumb() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBackButtonClick", function () {
      _this.props.historyCallback();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBreadCrumbClick", function (currentNode, id) {
      !currentNode && _this.props.navCallback && _this.props.navCallback(id);
    });
    return _this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.onKeyUp = function onKeyUp(evt, callback, currentNode, id) {
    if (evt.type == 'click' && !evt.shiftKey && !evt.ctrlKey && evt.nativeEvent.which !== 3 || evt.type == 'keyup' && evt.keyCode == 13) {
      callback(currentNode, id);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        ancestors = _this$props.ancestors,
        hideBackButton = _this$props.hideBackButton,
        className = _this$props.className,
        style = _this$props.style,
        textDir = _this$props.textDir,
        noTrailingSlash = _this$props.noTrailingSlash,
        hideCurrentNode = _this$props.hideCurrentNode; // show/hide back button node

    var backButtonNode = !hideBackButton && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_backbutton["default"], {
      buttonType: "nav_pane",
      onClick: this._onBackButtonClick,
      onKeyUp: function onKeyUp(evt) {
        return _this2.onKeyUp(evt, _this2._onBackButtonClick);
      }
    })); // create crumb item nodes


    var crumbNodes = ancestors.map(function (currVal, index, ancestorsArr) {
      var isValue = !!currVal.defaultName;
      var currentNode = index === ancestorsArr.length - 1;
      var hideNode = hideCurrentNode && currentNode && index !== 0;
      var breadcrumb;

      if (isValue && !hideNode) {
        breadcrumb = /*#__PURE__*/_react["default"].createElement(_BreadcrumbItem["default"], {
          tabIndex: 0,
          key: index,
          className: breadcrumbItemClassName,
          isCurrentPage: currentNode,
          onClick: function onClick() {
            return _this2._onBreadCrumbClick(currentNode, index);
          },
          onKeyUp: function onKeyUp(evt) {
            return _this2.onKeyUp(evt, _this2._onBreadCrumbClick, currentNode, index);
          }
        }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
          style: {
            userSelect: 'all'
          },
          label: currVal.defaultName,
          ellipsis: true,
          location: currentNode ? 'end' : 'middle',
          textDir: textDir
        }));
      }

      return breadcrumb;
    });
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Breadcrumb, {
      className: className,
      style: style,
      noTrailingSlash: noTrailingSlash
    }, backButtonNode, crumbNodes);
  };

  return Breadcrumb;
}(_react.Component);

exports["default"] = Breadcrumb;
(0, _defineProperty2["default"])(Breadcrumb, "propTypes", {
  /** Pass an array of js objects that detail the ancestors of the current crumb node. The minimum requirements are an id, a defaultName and an icon */
  ancestors: _propTypes["default"].array,

  /** pass a callback function that defines the behaviour when clicking on a crumb node */
  navCallback: _propTypes["default"].func,

  /** Pass a callback function that defines the behaviour of clicking the back button */
  historyCallback: _propTypes["default"].func,

  /** Pass a custom icon for the context menu. Default icon is folder-overflow_16 */
  menuIcon: BaPropTypes.deprecated('is ignored and not applicable to carbon breadcrumb'),

  /** String value to display different font-sizes Options: small, medium(default), large */
  size: BaPropTypes.deprecated('is ignored and not applicable to carbon breadcrumb'),

  /** Boolean value to hide the back button */
  hideBackButton: _propTypes["default"].bool,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Custom css styles */
  style: _propTypes["default"].object,

  /** text direction */
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),

  /** Optional prop to omit the trailing slash for the breadcrumbs */
  noTrailingSlash: _propTypes["default"].bool,

  /** Option to omit the current page node from the breadcrumb */
  hideCurrentNode: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Breadcrumb, "defaultProps", {
  ancestors: [],
  menuIcon: _folderOverflow_["default"],
  size: 'medium',
  hideBackButton: true,
  className: '',
  style: {},
  noTrailingSlash: false,
  hideCurrentNode: false
});

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/folder-overflow_16.js");

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baUiCarbon = __webpack_require__(12);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BreadcrumbItem = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(BreadcrumbItem, _Component);

  function BreadcrumbItem() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        isCurrentPage = _this$props.isCurrentPage,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["isCurrentPage"]);
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.BreadcrumbItem, (0, _extends2["default"])({
      isCurrentPage: isCurrentPage
    }, other));
  };

  return BreadcrumbItem;
}(_react.Component);

exports["default"] = BreadcrumbItem;
(0, _defineProperty2["default"])(BreadcrumbItem, "propTypes", {
  /** Provide if this breadcrumb item represents the current page */
  isCurrentPage: _propTypes["default"].node
});

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(164);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-breadcrumbItem .ba-common-label{color:#0f62fe}\n", ""]);

// exports
exports.locals = {
	"breadcrumbItemClassName": "\"ba-common-breadcrumbItem\""
};

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__19__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__59__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[158,0]]]);
});